import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "my-header d-flex" }
const _hoisted_2 = ["textContent", "id"]
const _hoisted_3 = {
  class: "d-flex align-items-center p-3 w-100",
  style: {"line-height":"1.4"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "wizard-icon me-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      fill: "currentColor",
      class: "bi bi-person-lines-fill",
      viewBox: "0 0 16 16"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z" })
    ])
  ])
], -1)
const _hoisted_5 = { class: "wizard-label text-start" }
const _hoisted_6 = { class: "fs-4 m-0 fw-bold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "wizard-desc",
  style: {"font-size":"0.8rem"}
}, null, -1)
const _hoisted_8 = {
  class: "d-flex align-items-center p-3 text-left w-100",
  style: {"line-height":"1.4"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "wizard-icon me-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      fill: "currentColor",
      class: "bi bi-image-fill",
      viewBox: "0 0 16 16"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M.002 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2zm1 9v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062zm5-6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0" })
    ])
  ])
], -1)
const _hoisted_10 = { class: "wizard-label text-start" }
const _hoisted_11 = { class: "fs-4 m-0 fw-bold" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "wizard-desc",
  style: {"font-size":"0.8rem"}
}, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "py-4 ps-0 pe-4"
}
const _hoisted_14 = {
  class: "d-flex align-items-center p-3 text-left w-100",
  style: {"line-height":"1.4"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "wizard-icon me-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      fill: "currentColor",
      class: "bi bi-folder-symlink-fill",
      viewBox: "0 0 16 16"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2l.04.87a2 2 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3M2.19 3q-.362.002-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672a1 1 0 0 1 .707.293L7.586 3zm9.608 5.271-3.182 1.97c-.27.166-.616-.036-.616-.372V9.1s-2.571-.3-4 2.4c.571-4.8 3.143-4.8 4-4.8v-.769c0-.336.346-.538.616-.371l3.182 1.969c.27.166.27.576 0 .742" })
    ])
  ])
], -1)
const _hoisted_16 = { class: "wizard-label text-start" }
const _hoisted_17 = { class: "fs-4 m-0 fw-bold" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "wizard-desc",
  style: {"font-size":"0.8rem"}
}, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "py-4 ps-0 pe-4"
}
const _hoisted_20 = {
  class: "d-flex align-items-center p-3 text-left w-100",
  style: {"line-height":"1.4"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "wizard-icon me-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      fill: "currentColor",
      class: "bi bi-info-circle-fill",
      viewBox: "0 0 16 16"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" })
    ])
  ])
], -1)
const _hoisted_22 = { class: "wizard-label text-start" }
const _hoisted_23 = { class: "fs-4 m-0 fw-bold" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "wizard-desc",
  style: {"font-size":"0.8rem"}
}, null, -1)
const _hoisted_25 = {
  key: 0,
  class: "py-4 ps-0 pe-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Anotations = _resolveComponent("Anotations")!
  const _component_swPerson = _resolveComponent("swPerson")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_PhotoManager = _resolveComponent("PhotoManager")!
  const _component_sFiles = _resolveComponent("sFiles")!
  const _component_LineTime = _resolveComponent("LineTime")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogProfile,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogProfile) = $event)),
    class: "bg-light",
    fullscreen: true,
    onOpen: _ctx.onOpen,
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed
  }, {
    header: _withCtx(({ titleId }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", {
          textContent: _toDisplayString(_ctx.listActions[_ctx.action].name),
          class: "fw-normal mb-0 w-300px",
          id: titleId
        }, null, 8, _hoisted_2),
        (_ctx.gblAccount?.ta == _ctx.ta)
          ? (_openBlock(), _createBlock(_component_Anotations, {
              key: 0,
              id: _ctx.dataProfile.idpayroll,
              target: 'payroll',
              status: _ctx.status
            }, null, 8, ["id", "status"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, {
        class: "tabs-custom",
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
        "tab-position": 'left',
        style: _normalizeStyle({ height: _ctx.altura + 'px', overflowY: 'auto' }),
        stretch: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, { name: "tab1" }, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('personalData')), 1),
                  _hoisted_7
                ])
              ])
            ]),
            default: _withCtx(() => [
              (_ctx.activeTab == 'tab1')
                ? (_openBlock(), _createBlock(_component_el_scrollbar, {
                    key: 0,
                    height: _ctx.altura<=500 ? '500px' : _ctx.altura+'px'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_swPerson, {
                        origin: 'payroll',
                        action: _ctx.action,
                        params: _ctx.dataProfile,
                        onOnResponse: _ctx.onResponse
                      }, null, 8, ["action", "params", "onOnResponse"])
                    ]),
                    _: 1
                  }, 8, ["height"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            name: "tab2",
            disabled: _ctx.disabled
          }, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t('photography')), 1),
                  _hoisted_12
                ])
              ])
            ]),
            default: _withCtx(() => [
              (_ctx.activeTab == 'tab2')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_PhotoManager, {
                      idperson: _ctx.dataProfile.idperson
                    }, null, 8, ["idperson"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_tab_pane, {
            name: "tab3",
            disabled: _ctx.disabled
          }, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.t('documentation')), 1),
                  _hoisted_18
                ])
              ])
            ]),
            default: _withCtx(() => [
              (_ctx.activeTab == 'tab3')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_sFiles, {
                      idacrd: _ctx.dataProfile.idperson,
                      target: 'payroll'
                    }, null, 8, ["idacrd"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_tab_pane, {
            name: "tab4",
            disabled: _ctx.disabled
          }, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.t('remarks')), 1),
                  _hoisted_24
                ])
              ])
            ]),
            default: _withCtx(() => [
              (_ctx.activeTab == 'tab4')
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createVNode(_component_LineTime, {
                      id: _ctx.dataProfile.idpayroll,
                      target: "payroll"
                    }, null, 8, ["id"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["modelValue", "style"])
    ]),
    _: 1
  }, 8, ["modelValue", "onOpen", "onOpened", "onClosed"]))
}